/**
 * The colour a congress space's partner content is tinted with: the Room's own
 * colour (the space is shared by the Room's partner), or a neutral ink for a
 * Room with none.
 */
export function partnerAccentColor(room: {
  primaryColor: string | null;
}): string {
  return room.primaryColor === null
    ? "var(--color-ds-slate-700)"
    : room.primaryColor;
}
